function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "129.375 122.903 86.277 86.276",
    width: 86.277,
    height: 86.276,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M 138.003 209.179 L 129.375 200.552 L 163.886 166.041 L 129.375 131.531 L 138.003 122.903 L 172.513 157.414 L 207.024 122.903 L 215.652 131.531 L 181.141 166.041 L 215.652 200.552 L 207.024 209.179 L 172.513 174.669 L 138.003 209.179 Z",
    style: {},
    transform: "matrix(1, 0, 0, 1, 0, 3.552713678800501e-15)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.00eb312b.svg";
export { ForwardRef as ReactComponent };